"use strict";

import Vue from "vue";
import VueTimeago from "vue-timeago";
const usrLocale = navigator.languages
  ? navigator.languages[0]
  : navigator.language;
Vue.use(VueTimeago, {
  name: "Timeago", // Component name, `Timeago` by default
  locale: usrLocale // Default locale
  // We use `date-fns` under the hood
});
